import { ICaseLawDocumentService } from "../service/CaseLawDocumentService";

export default class RevertCaseLawDocumentStatusInteractor {
  private caseLawDocumentService: ICaseLawDocumentService;

  constructor({ caseLawDocumentService }: any) {
    this.caseLawDocumentService = caseLawDocumentService;
  }

  async execute(caseLawDocumentId: number) {
    return this.caseLawDocumentService.revertCaseLawDocumentStatus(
      caseLawDocumentId
    );
  }
}
